module.exports = __webpack_public_path__ + "static/media/trending-icon.10208a45.png";